const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 1.0,
};

// The intersectionObserver checks if the element is visibile yet, and if yes, starts the animation 
const observer = new IntersectionObserver(observerHandler, observerOptions);

const targetElements = document.querySelectorAll(".facts-module__counter");
if (targetElements) {
  targetElements.forEach((counter) => {
    observer.observe(counter);
  });
}

/**
 * The function animates a counter by incrementing its value until it reaches a target value.
 * @param targetCounter - The HTML element that represents the counter that needs to be animated.
 */
function animateCounter(targetCounter) {
  const animationSpeed = 100
  const timeOutBetweenIncrease = 0
  const targetValue = targetCounter.dataset.max;
  let oldValue = +targetCounter.innerHTML;

  // calculating the step this way lets the counters finish equally fast, even if there are huge gaps between the numbers
  const step = Math.ceil(targetValue / animationSpeed);

  if (oldValue !== targetValue) {
    if (oldValue + step > targetValue) {
      oldValue = targetValue
    } else {
      oldValue += step
    }

    targetCounter.innerHTML = oldValue;

    window.setTimeout(() => {
      if (oldValue !== targetValue) {
        animateCounter(targetCounter);
      }
    }, timeOutBetweenIncrease);
  }
}

/**
 * The function observes elements and triggers an animation when they intersect with the viewport.
 * @param entries - An array of IntersectionObserverEntry objects, each representing one target element
 * being observed by the IntersectionObserver.
 * @param observer - The observer parameter is an instance of the IntersectionObserver class that is
 * used to observe changes in the intersection of a target element with its parent container or
 * viewport. It is passed as an argument to the observerHandler function to allow for the manipulation
 * of the observer instance within the function.
 */
function observerHandler (entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      animateCounter(entry.target);
      observer.unobserve(entry.target); // stop observing once triggered
    }
  });
}
